import { jsx as _jsx } from "react/jsx-runtime";
import { StickyBar, StickyBarVariant } from '@as/cotopaxi';
import { useDebounce } from '@yonderland/andes-react';
import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { HEADER_CONTAINER, MAIN_CONTENT_CONTAINER, NAVIGATION_HORIZONTAL, } from '../../../constants/DOMElementsConstants';
import { DELAY } from '../../../constants/GeneralConstants';
export const NavigationStickyBar = ({ children, isHidden }) => {
    const [shouldRender, setShouldRender] = useState(false);
    const [navigationEl, setNavigationEl] = useState(null);
    const setIsStickyNavPresent = (state) => {
        SITE.data = SITE.data || {};
        SITE.data.isStickyNavPresent = state;
    };
    const getIsStickyNavPresent = () => {
        var _a;
        return !!((_a = SITE === null || SITE === void 0 ? void 0 : SITE.data) === null || _a === void 0 ? void 0 : _a.isStickyNavPresent);
    };
    useEffect(() => {
        const stickyNavExists = getIsStickyNavPresent();
        if (!stickyNavExists) {
            setIsStickyNavPresent(true);
            const navigation = document.querySelector(NAVIGATION_HORIZONTAL);
            setNavigationEl(navigation);
            // This needed because the navigation menu gets hidden after the page loads with a delay
            setTimeout(() => setShouldRender(true), DELAY.DELAY_100);
        }
        return () => {
            setIsStickyNavPresent(false);
        };
    }, []);
    const stickyRef = useCallback(useDebounce((node) => {
        if (!node) {
            return;
        }
        const mainContent = document.querySelector(MAIN_CONTENT_CONTAINER);
        const headerContainer = document.querySelector(HEADER_CONTAINER);
        if (isHidden) {
            headerContainer === null || headerContainer === void 0 ? void 0 : headerContainer.style.removeProperty('margin-top');
            mainContent === null || mainContent === void 0 ? void 0 : mainContent.style.removeProperty('padding-top');
            return;
        }
        if (headerContainer) {
            headerContainer.style.marginTop = `${node.offsetHeight}px`;
        }
        else if (mainContent) {
            mainContent.style.paddingTop = `${node.offsetHeight}px`;
        }
    }, DELAY.DELAY_100), [isHidden]);
    if (!shouldRender || !navigationEl) {
        return null;
    }
    return createPortal(_jsx(StickyBar, { innerRef: stickyRef, isHidden: isHidden, variant: StickyBarVariant.NAVIGATION, withNavBar: true, children: children }), navigationEl);
};
